import React from 'react';
import { Fab } from '@mui/material';
import { ChevronRightIcon } from 'icons';
import { useStyles } from '../../styles';

const NextArrow = (props: any) => {
	const { onClick, className } = props;

	const { classes, cx } = useStyles();

	return (
		<Fab onClick={onClick} className={cx(className, classes.arrowBtn, classes.right)} size="large" aria-label="next">
			<ChevronRightIcon />
		</Fab>
	);
};

export default NextArrow;
